import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PrevServiceContainerService } from '../prev-service-container/prev-service-container.service';

@Injectable({ providedIn: 'root' })
export class PrevServiceGroupContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(
    private router: Router,
    private http: HttpClient,
    private previServiceContainerService: PrevServiceContainerService
  ) {}

  public getGroupServicos(id: string): Observable<any> {
    return this.getServicosGrupoContents(id).pipe(
      map(res => this.mapServicesGroup(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryServicosGrupoContents[0].data;
  }

  private getServicosGrupoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryServicosGrupoContents(filter: "id eq '${id}'"){
          data {
            nome {
              iv
            }
            title {
              iv
            }
            subtiltle {
              iv
            }
            listaServicos {
              iv {
                data {
                  nome {
                    iv
                  }
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  imagem {
                    iv {
                      url
                    }
                  }
                  icones {
                    iv {
                      titulo
                      uRL
                      modal {
                        id
                      }
                      imagem {
                        url
                      }
                    }
                  }
                  dicas {
                    iv {
                      descricao
                    }
                  }
                  descricao {
                    iv
                  }
                  corDestaque {
                    iv
                  }
                  botoes {
                    iv {
                      titulo
                      target {
                        ... on Formulario {
                          id
                        }
                      }
                      modal {
                        id
                      }
                      uRL
                      cor
                    }
                  }
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapServicesGroup(list) {
    const result = {
      title: list.title.iv,
      subtitle: list.subtiltle.iv,
      plans: list.listaServicos.iv.map(serv => {
        return this.previServiceContainerService.mapServices(serv.data);
      })
    };
    return result;
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
